import { render, staticRenderFns } from "./enterprises_data_ykf.vue?vue&type=template&id=1365a966&scoped=true&"
import script from "./enterprises_data_ykf.vue?vue&type=script&lang=js&"
export * from "./enterprises_data_ykf.vue?vue&type=script&lang=js&"
import style0 from "./enterprises_data_ykf.vue?vue&type=style&index=0&id=1365a966&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1365a966",
  null
  
)

export default component.exports